function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Col, Form, Row } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSnackbar } from 'notistack';
import { BackButton, Button, PermissionAlert } from '../../core/components';
import { isEmpty, isPresent, validUrl } from '../../core/utils';
import './form.scss';
// import {assignmentAssign, assignmentDelete, assignmentUpdate} from "../action";
import AssignmentTemplatesModal from "../../assignmentTemplates/assignmentTemplatesModal";
import { createAssignmentTemplate, deleteAssignmentTemplate, updateAssignmentTemplate } from "../../assignmentTemplates";
import { DeleteModal } from "../../core/components/modals";
import AssignmentBasicsForm from "./AssignmentBasicsForm";
import AssignmentGradingForm from "./AssignmentGradingForm";
// import AssignmentAssignAndSchedule from "./AssignmentAssignAndSchedule";
import CancelModal from "./CancelModal";

/**
 * @param assignment
 * @param onUpdate
 * @param content This is the resource in context, could be one of ['assignment', 'assignment_template']
 * @returns {JSX.Element}
 * @constructor
 */
var AssignmentForm = function AssignmentForm(_ref) {
  var assignment = _ref.assignment,
    onUpdate = _ref.onUpdate,
    content = _ref.content;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    baseAssignmentObjectives = _useState2[0],
    setBaseAssignmentObjectives = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    studentsList = _useState4[0],
    setStudentsList = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    buttonDisabled = _useState6[0],
    setButtonDisabled = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    nextButtonLoading = _useState8[0],
    setNextButtonLoading = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    draftButtonLoading = _useState10[0],
    setDraftButtonLoading = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showTemplateModal = _useState12[0],
    setShowTemplateModal = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    templateCreateLoading = _useState14[0],
    setTemplateCreateLoading = _useState14[1];
  var _useState15 = useState(content === 'assignment_template' ? assignment.visibility : ''),
    _useState16 = _slicedToArray(_useState15, 2),
    templateFor = _useState16[0],
    setTemplateFor = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    templateName = _useState18[0],
    setTemplateName = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    templateModalState = _useState20[0],
    setTemplateModalState = _useState20[1];
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    templateSharableCode = _useState22[0],
    setTemplateSharableCode = _useState22[1];
  var _useState23 = useState({}),
    _useState24 = _slicedToArray(_useState23, 2),
    savedTemplate = _useState24[0],
    setSavedTemplate = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showDeleteModal = _useState26[0],
    setShowDeleteModal = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    showCancelModal = _useState28[0],
    setShowCancelModal = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    deleting = _useState30[0],
    setDeleting = _useState30[1];
  var _useSnackbar = useSnackbar(),
    enqueueSnackbar = _useSnackbar.enqueueSnackbar;
  var isValidOneNote = function isValidOneNote(value) {
    if (!value) {
      return true;
    }
    return validUrl(value) && value.includes('sharepoint.com');
  };
  var schema = yup.object().shape({
    'name': yup.string().max(256, 'Name cannot exceed 256 characters.').required('You must give this assessment a name.').nullable(),
    'description': yup.string().required('You must give this assessment a description.').nullable(),
    'assignment_objectives': yup.array().of(yup.object().shape({
      slug: yup.mixed(),
      name: yup.string().required('You must add at least 1 learning objective')
    })),
    'rubrics': yup.array().of(yup.object()).nullable(),
    'max_marks': yup.mixed().when(['graded', 'grade_display_to_students'], function (graded, grade_display_to_students) {
      if (graded && grade_display_to_students !== 'rubrics') {
        return yup.number().required('You must add maximum marks to this or else turn off grading.').transform(function (value) {
          return isNaN(value) ? undefined : value;
        }).min(1, 'The minimum allowable mark is 1').nullable();
      }
    }),
    'grade_display_to_students': yup.string('Please select one type of grade from the list.').nullable().when('graded', {
      is: true,
      then: yup.string().required('Please select one type of grade from the list.').nullable()
    }),
    'publish_at': yup.date().when('scheduled', {
      is: true,
      then: yup.date().max(yup.ref('due_at'), 'Schedule date should be before assignment due date')
    }),
    'due_at': yup.date(),
    'onenote_url': yup.string().test("Valid Onenote URL", "Invalid Onenote URL", isValidOneNote).nullable()
  });
  var formConfig = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      assignment_objectives: [{
        name: ''
      }]
    }
  });
  var handleSubmit = formConfig.handleSubmit,
    watch = formConfig.watch,
    setValue = formConfig.setValue,
    getValues = formConfig.getValues;
  var assignmentName = watch('name');
  var deleteButtonText = function deleteButtonText() {
    if (content === 'assignment_template') return 'Template';
    if ((assignment === null || assignment === void 0 ? void 0 : assignment.status) === 'draft') return 'Draft';
    return 'Assessment';
  };
  var toggleDeleteModal = function toggleDeleteModal() {
    return setShowDeleteModal(!showDeleteModal);
  };
  var closeCancelModal = function closeCancelModal() {
    return setShowCancelModal(false);
  };
  var closeTemplateModal = function closeTemplateModal() {
    setShowTemplateModal(false);
  };
  var checkKeyDown = function checkKeyDown(e) {
    if (e.key === 'Enter' && e.target.tagName.toLowerCase() !== 'textarea') e.preventDefault();
  };
  var onAssign = function onAssign(students) {
    return setStudentsList(students);
  };

  // const assignToStudents = async () => {
  //   const checkedStudents = studentsList;
  //   const unCheckedStudents = [];
  //   let activity, teams_user_ids;
  //
  //   for (const id in assignment.students) {
  //     if (!studentsList.includes(id)) unCheckedStudents.push(id)
  //   }
  //
  //   // If we are editing the assignment and some students were not checked, we use the unassign action to
  //   // unassign the students that were not checked.
  //   // Otherwise if it is a new assignment we use the assign action to assign the students that were checked
  //   if (unCheckedStudents.length > 0 && assignment.status !== 'draft') {
  //     activity = 'unassign'
  //     teams_user_ids = unCheckedStudents
  //   } else if (checkedStudents.length > 0) {
  //     activity = 'assign'
  //     teams_user_ids = checkedStudents
  //   } else {
  //     return // No student to assign
  //   }
  //
  //   const payload = { activity, teams_user_ids }
  //   await dispatch(assignmentAssign(assignment.id, payload))
  // }

  var validateRubrics = function validateRubrics(data) {
    if (data.grade_display_to_students === 'rubrics') {
      if (isEmpty(data.rubrics)) {
        throw new Error('Rubrics is not added for grading type rubrics');
      } else if (data.rubrics.length !== data.assignment_objectives.length) {
        throw new Error('Rubrics and assignment objectives length do not match');
      }
    }
  };
  var onSubmit = function onSubmit(data) {
    console.log(data);
  };
  // const onSubmit = async data => {
  //   try {
  //     validateRubrics(data);
  //     setNextButtonLoading(true);
  //     setButtonDisabled(true);
  //
  //     const payload = formatPayload(data)
  //     const response = await dispatch(assignmentUpdate(assignment.id, payload, false))
  //     if (response.status !== 'draft') {
  //       await assignToStudents();
  //       navigateTo(`/assignments/${assignment.id}?refresh=true&templateFor=${assignment.templateFor || ''}`)
  //     }
  //   } catch (e) {
  //     enqueueSnackbar(e.message, { variant: 'error' })
  //   } finally {
  //     setNextButtonLoading(false);
  //     setButtonDisabled(false);
  //   }
  // };

  // const saveDraft = async (data, navigate = true) => {
  //   try {
  //     validateRubrics(data);
  //     setDraftButtonLoading(true);
  //     setButtonDisabled(true);
  //
  //     const payload = formatPayload(data, { saveDraft: true })
  //
  //     const response = await dispatch(assignmentUpdate(assignment.id, payload))
  //     if (navigate) {
  //       onUpdate(response)
  //       navigateTo(`/assignments/${assignment.id}`);
  //     } else {
  //       return response
  //     }
  //   } catch (e) {
  //     if (!navigate) return Promise.reject(e)
  //     else enqueueSnackbar(e.message, { variant: 'error' })
  //   } finally {
  //     setDraftButtonLoading(false);
  //     setButtonDisabled(false);
  //   }
  // };

  // const saveTemplate = async (data) => {
  //   try {
  //     setTemplateCreateLoading(true)
  //
  //     // If we are creating a template for the first time from an assignment, we first create a draft assignment
  //     // and create a template from the draft assignment .
  //     // otherwise if the content is assignment_template, it means we are editing an assignment template
  //     // in that case we do not need to create a draft before saving since the template was initially created
  //     // from a draft.
  //     const sourceAssignment = content === 'assignment' ? await saveDraft(data, false) : assignment;
  //     const query = { assignment_id: sourceAssignment.id, assignment_type: 'ms_teams', visibility: templateFor, template_name: templateName };
  //
  //     const response = await dispatch(createAssignmentTemplate(query));
  //     setSavedTemplate(response);
  //     setTemplateSharableCode(response.sharable_code)
  //
  //     setBaseAssignmentObjectives(sourceAssignment.assignment_objectives);
  //     setTemplateModalState(1); // show the success page on the template modal
  //   } catch (e) {
  //     enqueueSnackbar(e.message, { variant: 'error' })
  //   } finally {
  //     setTemplateCreateLoading(false)
  //   }
  // };

  // const handleDeleteAssignment = async () => {
  //   try {
  //     setDeleting(true);
  //     await dispatch(assignmentDelete(assignment.id));
  //     setShowDeleteModal(true);
  //     enqueueSnackbar('Assignment was Deleted', { variant: 'success' });
  //     navigateTo('/tab?activeTab=assignments')
  //   } catch (e) {
  //     enqueueSnackbar(e.message, { variant: 'error' });
  //   } finally {
  //     setDeleting(false);
  //   }
  // }

  var handleDeleteAssignmentTemplate = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setDeleting(true);
            _context.next = 4;
            return deleteAssignmentTemplate(assignment.id);
          case 4:
            setShowDeleteModal(false);
            enqueueSnackbar('Assignment template was Deleted', {
              variant: 'success'
            });
            Turbolinks.visit('/templates');
            // window.location.href = '/templates';
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            enqueueSnackbar(_context.t0.message, {
              variant: 'error'
            });
          case 12:
            _context.prev = 12;
            setDeleting(false);
            return _context.finish(12);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9, 12, 15]]);
    }));
    return function handleDeleteAssignmentTemplate() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleDelete = function handleDelete() {
    // const handlers = { assignment: handleDeleteAssignment, assignment_template: handleDeleteAssignmentTemplate };
    // handlers[content]();
    handleDeleteAssignmentTemplate();
  };
  var handleTemplateEdit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
      var payload;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            payload = _objectSpread(_objectSpread({}, data), {}, {
              visibility: templateFor,
              template_name: templateName
            });
            payload.assignment_objectives = JSON.stringify(payload.assignment_objectives);
            delete payload.publish_at; // assignment templates does not have published at

            if (isPresent(payload['rubrics']) && payload.grade_display_to_students === 'rubrics') {
              payload['rubrics'] = JSON.stringify(payload.rubrics);
            }
            setNextButtonLoading(true);
            setButtonDisabled(true);
            _context2.next = 9;
            return updateAssignmentTemplate(assignment.id, payload);
          case 9:
            enqueueSnackbar('Assignment Template was updated', {
              variant: 'success'
            });
            Turbolinks.visit('/templates');
            // window.location.href = '/templates'
            _context2.next = 16;
            break;
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](0);
            enqueueSnackbar(_context2.t0.message, {
              variant: 'error'
            });
          case 16:
            _context2.prev = 16;
            setNextButtonLoading(false);
            setButtonDisabled(false);
            return _context2.finish(16);
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 13, 16, 20]]);
    }));
    return function handleTemplateEdit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onSubmitTemplateForm = function onSubmitTemplateForm() {
    var submissionHandler = content === 'assignment_template' ? handleTemplateEdit : saveTemplate;
    handleSubmit(submissionHandler, templateValidationError)();
  };
  var templateValidationError = function templateValidationError(e) {
    console.error(e);
    enqueueSnackbar('Please fill out the assessment form correctly to be able to save it as a template', {
      variant: 'error'
    });
  };
  var draftValidationError = function draftValidationError() {
    setShowCancelModal(false);
    enqueueSnackbar('Please fill out the assessment form correctly to be able to save it as a draft', {
      variant: 'error'
    });
  };
  var formatPayload = function formatPayload(payload) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isRubric = isPresent(payload['rubrics']) && payload.grade_display_to_students === 'rubrics';
    if (payload.assignment_objectives) {
      payload.show_assignment_objectives = true;
      payload['assignment_objectives_attributes'] = payload.assignment_objectives.map(function (item, index) {
        item['order'] = index + 1;
        if (item.slug) item['id'] = item.slug;
        delete item.slug;
        return item;
      });
      if (isRubric && payload['rubrics'][0]['columns'].length) {
        var columns = payload['rubrics'][0]['columns'];
        payload['rubric_columns_attributes'] = columns.map(function (column) {
          var result = {
            name: column.name,
            order: column.order,
            point: column.point
          };
          if (column['id']) result['id'] = column['id'];
          if (column['_destroy']) result['_destroy'] = column['_destroy'];
          return result;
        });
      }
    }
    if (payload['due_at'] && Array.isArray(payload['due_at'])) payload['due_at'] = payload['due_at'][0].toJSON();
    if (payload['publish_at'] && Array.isArray(payload['publish_at'])) payload['publish_at'] = payload['publish_at'][0].toJSON();
    if (!payload['scheduled']) delete payload.publish_at;
    delete payload.scheduled;
    payload.save_draft = options.saveDraft;
    return payload;
  };
  useEffect(function () {
    if (isPresent(assignment)) {
      var fieldsToUpdate = ['name', 'description', 'feedback_type', 'max_marks', 'graded', 'due_at', 'publish_at', 'publish_at', 'submission_type', "onenote_url", "rubrics", "visibility"];
      if (assignment.graded) fieldsToUpdate.push('grade_display_to_students');

      /* Default dates should be set to one week from present time */
      var oneWeekFromNow = new Date();
      oneWeekFromNow.setDate(oneWeekFromNow.getDate() + 7);
      var assignmentClone = _objectSpread({}, assignment);
      assignmentClone['due_at'] = assignmentClone['due_at'] || oneWeekFromNow;
      assignmentClone['publish_at'] = assignmentClone['publish_at'] || oneWeekFromNow;

      /** Update these fields with the value from the backend **/
      fieldsToUpdate.forEach(function (item) {
        return setValue(item, assignmentClone[item]);
      });
      if (assignment.publish_at) setValue('scheduled', true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignment]);
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(PermissionAlert, null), /*#__PURE__*/React.createElement(BackButton, null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "px-1 px-md-3"
  }, /*#__PURE__*/React.createElement(Form, {
    className: "assignment-form",
    onSubmit: handleSubmit(onSubmit),
    onKeyDown: function onKeyDown(e) {
      return checkKeyDown(e);
    }
  }, /*#__PURE__*/React.createElement(AssignmentBasicsForm, {
    formConfig: formConfig,
    assignment: assignment,
    content: content,
    formatPayload: formatPayload,
    baseAssignmentObjectives: baseAssignmentObjectives,
    onUpdate: onUpdate
  }), /*#__PURE__*/React.createElement(AssignmentGradingForm, {
    formConfig: formConfig,
    assignment: assignment
  }), /*#__PURE__*/React.createElement("div", {
    className: "pt-4 pb-5 mb-4 d-flex justify-content-between flex-wrap"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    disabled: buttonDisabled,
    color: "white",
    outline: true,
    className: "text-danger",
    onClick: function onClick() {
      return setShowDeleteModal(true);
    }
  }, "Delete ", deleteButtonText())), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    disabled: buttonDisabled,
    className: "me-2 text-primary",
    onClick: function onClick() {
      return setShowCancelModal(true);
    },
    outline: true,
    color: "white"
  }, "Cancel"), content === 'assignment' && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    outline: true,
    color: "dark",
    disabled: buttonDisabled,
    withLoader: true,
    loading: templateCreateLoading,
    loaderText: "Saving",
    className: "me-2",
    onClick: function onClick() {
      return setShowTemplateModal(true);
    }
  }, "Save as template"), content === 'assignment' && /*#__PURE__*/React.createElement(Button, {
    disabled: buttonDisabled,
    type: "submit",
    withLoader: true,
    loading: nextButtonLoading,
    loaderText: "Loading"
  }, "Assign ", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faArrowRight,
    className: "ms-2"
  })), content === 'assignment_template' && /*#__PURE__*/React.createElement(Button, {
    disabled: buttonDisabled,
    type: "button",
    withLoader: true,
    loading: nextButtonLoading,
    loaderText: "Loading",
    onClick: function onClick() {
      return setShowTemplateModal(true);
    }
  }, "Save template")))))), /*#__PURE__*/React.createElement(AssignmentTemplatesModal, {
    assignment: assignment,
    defaultAssignmentName: assignmentName,
    savedTemplate: savedTemplate,
    isOpen: showTemplateModal,
    templateCreateLoading: templateCreateLoading,
    templateModalState: templateModalState,
    sharableCode: templateSharableCode,
    onChangeTemplate: function onChangeTemplate(visibility, templateName) {
      setTemplateFor(visibility);
      setTemplateName(templateName);
    },
    onClose: closeTemplateModal,
    onSubmit: onSubmitTemplateForm
  }), /*#__PURE__*/React.createElement(DeleteModal, {
    toggle: toggleDeleteModal,
    show: showDeleteModal,
    onDelete: handleDelete,
    text: "Are you sure you want to delete this item?",
    submitting: deleting
  }), /*#__PURE__*/React.createElement(CancelModal, {
    show: showCancelModal,
    onClose: closeCancelModal,
    context: content,
    assignment: assignment,
    onSaveDraft: handleSubmit(function () {
      return console.log('s');
    }, draftValidationError),
    submitting: draftButtonLoading
  }));
};
AssignmentForm.defaultProps = {
  onUpdate: undefined,
  content: 'assignment'
};
export default AssignmentForm;